import React from 'react';

function NotFound({lang,toggleTheme}) {
  return (
    <div></div>
  );
}

export default NotFound;
